<template>
<vue-markdown>
#### 1. 导入excel发货
这个系统可以导入excel批量发货。在打印厂使用自己的系统生成快递号的情况下使用， 点击下图`导入订单发货`按钮即可。

![](/assets/docs/send-order-manually.png)

1. 导入的文件不支持office2003的格式，表格的第一行为标题，不会作为数据导入
2. 如果导入excel里面有多张表单，我们会导入第一张表单
3. 导入excel发货后，我们会返回一张类似的excel，里面记录的是每一条订单发货导入的结果如果失败，会红色高亮显示
4. excel表格内容如下
5. 你可以[在此](/static/data/发货.xlsx)下载模板

| 公司代码    | 外部订单号   |  快递公司  | 快递单号 |
| --------   | :-----         |   ---    | :----:  |
| zhifubao  | 201710112344   |   shunfeng/顺丰 | 617102986583 |
| weixin   | 35621          |   yuantong/圆通 | 811677241027 |
| meipian    | 07158945554222 |  yuantong/圆通  | 811677242533 |


#### 2. 扫码发货
将鼠标放置到下图中的`扫码发货`输入框内，使用扫码抢扫描快递单号，即可实现获取快递单号的功能。
![](/assets/docs/scan-send.png)

注意事项：
1. 如果一个订单含有多册或者多份，比如上图，册数和份数会用红色标记，注意不要漏发
2. `已发货`的订单，不能获取快递单号。如因特殊原因需要的，请先手动设置订单的状态为其他
3. 如果一个订单已经获取了快递单号，再次扫码获取会提醒“该订单已有运单号。确认是否重新获取“
  * 如果是是售后件，则新的快递单号是必须生成的， 点击“是”
  * 如果是误操作，操作员不小心重复扫码了，则点击“否”，不用生成新快递单号
  * 如果是误操作，且操作员不小心点击了“是”，获取了新的快递单号，这并不会造成太大问题


#### 3. 发货的快递公司
第三方公司如果指明使用顺丰发货，我们会向顺丰请求面单。指明非顺丰发货的，打印厂可以自由使用自己签约的快递公司。

顺丰包含两个选项：`顺丰次日` 和 `顺丰隔日`。二者时效性不同，前者贵且快，后者便宜慢。默认使用`顺丰次日`，非特殊情况请不要修改。


#### 4. 关于有运单号和待取件
![](/assets/docs/send-order-operation.png)
发货界面将订单分为两类， 分别是`有运单号`和`待取件`。选中订单后点击上图的按钮可以将订单在这两个分类之间自由移动。
简而言之，**如果快递员当日不能取走货物， 请将订单移动到`待取件`里面**。

执行这个操作的原因是点击`发货`按钮后， 第三方公司会立即通知用户订单的快递公司以及快递号。如果快递员不能在当天揽件，而用户收到了通知，会产生疑问。


</vue-markdown>
</template>

<script>
import VueMarkdown from 'vue-markdown'

export default {
  name: 'help-send-orders',
  components: {
    'vue-markdown': VueMarkdown
  }
}
</script>